let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6qah4"), load("4odwV")]).then(() => parcelRequire('aTxPF'));